import { DateTime } from 'luxon';
const asDate = (iso) => DateTime.fromISO(iso, { zone: 'utc' }).startOf('day');
const iso = (date) => date.toISODate() ?? '';
const isSameRow = (selection, cell) => selection.unitGroupId === cell.unitGroupId &&
    selection.ratePlanId === cell.ratePlanId;
const anchorAt = (cell) => ({
    unitGroupId: cell.unitGroupId,
    ratePlanId: cell.ratePlanId,
    start: cell.date,
    end: cell.date,
    phase: 'anchored'
});
// The next selection after clicking `cell`. A click on a different row (or the
// first click of all) anchors a fresh selection; a second click on the anchored
// row commits the contiguous range between the two nights; a click on an
// already-ranged row starts over from that night.
export const nextSelection = (current, cell) => {
    if (!current || !isSameRow(current, cell) || current.phase === 'ranged') {
        return anchorAt(cell);
    }
    const anchor = asDate(current.start);
    const clicked = asDate(cell.date);
    const [start, end] = clicked < anchor ? [clicked, anchor] : [anchor, clicked];
    return {
        unitGroupId: current.unitGroupId,
        ratePlanId: current.ratePlanId,
        start: iso(start),
        end: iso(end),
        phase: 'ranged'
    };
};
// True when a night falls within a row's current selection — drives the cell
// highlight in the calendar.
export const isCellSelected = (selection, cell) => {
    if (!selection || !isSameRow(selection, cell)) {
        return false;
    }
    const date = asDate(cell.date);
    return date >= asDate(selection.start) && date <= asDate(selection.end);
};
// The number of nights in a committed selection (`end` inclusive of its night).
export const selectionNights = (selection) => Math.max(Math.round(asDate(selection.end).diff(asDate(selection.start), 'days').days) + 1, 1);
// The stay's departure date: the night after the last selected night, matching
// the half-open [arrival, departure) offers contract.
const departureAfter = (lastNight) => iso(asDate(lastNight).plus({ days: 1 }));
// Maps a committed selection to a fresh offers request for that exact stay. The
// resolved offer — not any calendar cell — carries the bookable total.
export const selectionToOffersRequest = (selection, propertyId, adults) => ({
    propertyId,
    arrival: selection.start,
    departure: departureAfter(selection.end),
    adults
});
